/**
 * `components.MuiTab` & `MuiTabs` — tab strip background, label color, dark-mode selected state.
 * Discoverability: `MuiTabs`, `MuiTab`, `Tabs`, `Tab`, `textColor`.
 *
 * @see https://mui.com/material-ui/api/tabs/
 * @see https://mui.com/material-ui/api/tab/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiTabs(theme: Theme): Pick<Components<Theme>, 'MuiTab' | 'MuiTabs'> {
  const { palette } = theme;
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          color: theme.palette.text.secondary,
        },
        textColorPrimary: {
          ...(palette.mode === 'dark' && {
            '&.Mui-selected': {
              color: theme.palette.primary.main,
            },
          }),
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          background: theme.palette.background.paper,
        },
      },
    },
  };
}
